<script lang="ts">

    import {createEventDispatcher, onDestroy, onMount} from "svelte";
    import type {Region} from "../../models/model";
    import { tweened } from 'svelte/motion';
    import {backIn, backInOut, backOut, bounceOut, cubicIn, cubicOut} from 'svelte/easing';
    import type {Color} from "../../map";
    import {SVGMap} from "../../map";

    //  import {Color, SVGMap} from "../../Map.svelte"; old import



   const size = tweened(0, {
        duration: 200,
        easing:backInOut,
        delay:800,

    });

    function animateMap() {

        size.set(1)
        /*
        //size.duration = 300;
        console.log("animate!");
        size.set(0.9)
        setTimeout(() => {
            console.log("animate back!");
            size.set(1.1);

        }, 500);
        setTimeout(() => {
            console.log("animate back!");
            size.set(0.9);
        }, 1000);

        setTimeout(() => {
            console.log("animate back!");
            size.set(1);
        }, 1500);
*/



    }

   export let ready:boolean  = false;
    export let path: string;
    export let regions: Region[] = [];
    export let fills: {
	    [key: string]: Color
    } = {};
    export let markings: {
	    [key: string]: 'striped' | 'dotted'
    } = {};
	export let lastClicked: string | null = null;
	export let svgStyles = '';
	export let loaded = false;

    let preSelection:string | null;
    let object: HTMLObjectElement;
    let map: SVGMap | null = null;
    const dispatch = createEventDispatcher<{
	    communityClick: string,
	    communityHover: {
		    key: string,
		    e: MouseEvent
	    },
	    communityUnhover: string,
	    loaded: null,
	    error: any,
    }>();
    let _loaded = false;


    onMount(() => {
         const currentUrl = new URL(window.location.href);
        const params = currentUrl.searchParams;
        preSelection = params.get('selectedCommunity');

    });
    //console.log("fills:");
    //console.log(fills);
    // set default fills when regions change
    $: {

        //this will set the region color (4 groups) and not the community colors.
       setFillsFromRegions(regions || []);

       if (!ready && map && regions.length > 0 && Object.keys(fills).length > 0) {
           console.log("map loading condition true", {map:map, regions:regions, fills:fills, ready: ready})

           ready = true;

           console.log("map + regions loaded!", fills);

                //this will set the final community color depending on pact status
               map.fillCommunities(fills)

           if(preSelection){
               // map.setLastClicked(preSelection);
               console.log(":::preselection = ", preSelection)
               lastClicked = preSelection;
               dispatch('communityClick', preSelection);
              // console.log(":::map = ", map);
               setTimeout(() => {
                   if(map){
                       map.setLastClicked(preSelection);

                   }

               },100)

           }else{
                console.log(':::no preselection');
           }



       }else{
           console.log("not loaded yet!", {map:map, regions:regions,fills:fills, ready: ready})
       }
    }
    //$: if (map) map.fillCommunities(fills);
    // fill / mark specified communities
    //$: if (map) map.fillCommunities(fills);
    //$: if (map) map.markCommunities(markings); //not needed for mfi
	//TODO check if needed somewhere else $: if (map) map.setLastClicked(lastClicked);

    onDestroy(() => {
	    if (map) {
            console.log("destroy map!!!")
		    map.destroy();
            ready = false;

        }
    });

    function svgLoaded() {
        setTimeout(() => {
            _loaded = true;
            initMap();
        },1000);
    }

    export function resetMap(){
        if(map){
            map.restoreCommunities();

        }
    }
   export function setFillFromSearch(key:string|null = null,f:any){

      // const params = new URLSearchParams(window.location.search);
       if(key) {
      //      params.delete('selectedCommunity');
       }

     //  const newUrl = `${window.location.pathname}?${params.toString()}`;
     //  window.history.pushState({}, '', newUrl); // or replaceState if you don't want to add to history

        /*
       const params = new URLSearchParams(window.location.search);
       if(key){
           params.set('selectedCommunity', key);
       }else{
           params.delete('selectedCommunity');
       }

       const newUrl = `${window.location.pathname}?${params.toString()}`;
       window.history.pushState({}, '', newUrl); // or replaceState if you don't want to add to history
     */

       // fills = f;
        //reset all:
      // console.log("fills before", f);
       //map.fillCommunities({})
       console.log("search key???",key)

       if(map){


           //reset all paths first:
           //map.resetLastClicked();
           map.resetFills();
           //map.setFills({},true);
           //new start
           if(key) {

              // lastClicked = null;
              dispatch('communityClick', key);
               setTimeout(() => {
                   if (map) {
                       map?.setLastClicked(key);

                   }

               }, 100)
           }

           //new end


           //set new path and restore previous one.
           if(key){
            //TT   map.setLastClicked(key);
           }


           //overwrite all paths
           //XX BUG starts here:
           //TT map.setFills({},true);
           //x

           //console.log("key???",key)

           //set new path as current selected one.
           if(key){
               setTimeout(() => {
                  //TT  map?.setLastClicked(key);

               },100)
           }

       }




    }

    function initMap() {

        console.log(":::initMap()",map)
	    if (!_loaded) {
		    return;
	    }
	    if (map) {
		    map.destroy();
	    }

        console.log(":::create new!");
	    map = new SVGMap(
		    id => {
				lastClicked = id;
				dispatch('communityClick', id);
		    },
		    (id, e) => dispatch('communityHover', {key: id, e}),
		    id => dispatch('communityUnhover', id),
            mapType,
		    "#FDEED6", //defaultFocusColor
		    object,
            '#d9d9d9', //disableColor
            '#F7A833', //defaultHoverColor
            '#F7A833' //defaultStrokeColor
	    );
		loaded = true;
	    dispatch('loaded');
    }

    function setFillsFromRegions(regions: any[]) {
	    if (!map)
		    return;

	    const colorMap: { [key: string]: Color } = {};
	    for (let r of regions) {
		    const communities = r.communities;
		    for (let c of communities) {
			    colorMap[c.key] = '#d9d9d9'; //TODO revert afterwards r.color;
			   //  colorMap[c.key] = '#ee0'; // for testing
		    }
	    }
        //console.log("colorMap:");
        //console.log(colorMap);
        if(mapType == 'full'){
            map.setFills(colorMap);
        }else{
            map.setFills(colorMap,true);
        }

    }



</script>

<object title="Map" bind:this={object} on:error={e => dispatch('error', e)}
        on:load={svgLoaded} data={path}
        on:load={animateMap}
        style="transform:scale({$size}); width: 100%; {svgStyles}" type="image/svg+xml">
</object>

<style>



</style>

